import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiXCircle, FiCheckCircle } from 'react-icons/fi';
import { SectionHeading } from '../ui/SectionHeading';

export const ProblemSolution = () => {
  const problems = [
    "No clear direction",
    "No system",
    "No support",
    "Overwhelm from too many tools",
    "No leads / no sales"
  ];

  const solutions = [
    "Learn → Implement → Earn model",
    "Step-by-step roadmap",
    "Guided execution",
    "Community support",
    "Proven frameworks"
  ];

  return (
    <section className="py-24 px-4 bg-navy-900 border-b border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20">
          
          {/* Problem Column */}
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-red-500/5 border border-red-500/10 rounded-3xl p-8 md:p-12 relative overflow-hidden"
          >
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-500/0 via-red-500/50 to-red-500/0"></div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8">
              Why Most People <span className="text-red-400">Struggle</span> to Make Money Online
            </h3>
            <ul className="space-y-6">
              {problems.map((prob, idx) => (
                <motion.li 
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.1 }}
                  key={idx} 
                  className="flex items-start gap-4 text-gray-300 text-lg"
                >
                  <SafeIcon icon={FiXCircle} className="text-red-400 shrink-0 mt-1 text-xl" />
                  <span>{prob}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Solution Column */}
          <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-royal-600/5 border border-royal-500/20 rounded-3xl p-8 md:p-12 relative overflow-hidden shadow-[0_0_40px_rgba(37,99,235,0.05)]"
          >
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-royal-500/0 via-royal-500 to-royal-500/0"></div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8">
              This Is Not Just a Course — It’s a <span className="text-royal-400">Complete System</span>
            </h3>
            <ul className="space-y-6">
              {solutions.map((sol, idx) => (
                <motion.li 
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.1 }}
                  key={idx} 
                  className="flex items-start gap-4 text-white text-lg font-medium"
                >
                  <SafeIcon icon={FiCheckCircle} className="text-royal-400 shrink-0 mt-1 text-xl" />
                  <span>{sol}</span>
                </motion.li>
              ))}
            </ul>
          </motion.div>

        </div>
      </div>
    </section>
  );
};